






































































import { Component, Ref, Vue, Emit, Model, Provide } from 'vue-property-decorator';
import { getBrandsList, delBrand, getPagination } from '@/utils/api';
import reset from '../reset/reset.vue';
import AddBrand from './add_brand.vue';
import empty from '@/components/empty/empty.vue';
import { RuleFormInterface, RulesForm } from '../interface';
import tableEmpty from '@/components/empty/tableEmpty.vue';

@Component({
  components: {
    reset,
    AddBrand,
    empty,
    tableEmpty,
  },
})
export default class Brand extends Vue {
  nameTxt: string = '您还未添加任何品牌哦~';
  tables: Array<string> = ['品牌名称', '品牌ID', '品牌下商品数量', '操作'];
  isempty: boolean = true; //是否为空
  ruleForm: RuleFormInterface = { brandName: '' };
  Title: string = ''; //抽屉的title
  dialog: boolean = false; //抽屉默认样式
  currentPage: number = 1;
  pagesize: number = 20;
  total: number = 100;
  //点击编辑时发给子组件的参数
  PropsData: object = {};
  table_row: object = {};
  //表格下操作的删除按钮默认不显示
  isDelete: string = '删除';
  //表格的数据
  tableData: Array<object> = [];
  // 搜索品牌名称的验证规则
  rules: RulesForm = {
    name: [
      { required: true, message: '请输入活动名称', trigger: 'blur' },
      { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
    ],
  };
  $bus: any;
  loading: boolean = true;
  created() {
    this.getPagination(0);
  }
  getPagination(page) {
    this.loading = true;
    getPagination({
      page: page,
      size: 20,
      brandName: this.ruleForm.brandName,
      sort: 'createdDate',
    })
      .then((data: any) => {
        if (data) {
          this.isempty = true;
          this.tableData = data.content;
        } else {
          this.isempty = false;
          this.nameTxt = '您搜索的暂无找到';
        }
        this.currentPage = data.number + 1;
        this.pagesize = data.size;
        this.total = data.totalElements;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  //请求品牌列表的方法
  GetBrandsList() {
    getBrandsList({
      brandName: this.ruleForm.brandName,
      sort: 'createdDate',
    }).then((data: any) => {
      if (data) {
        this.isempty = true;
        this.tableData = data.content;
      } else {
        this.isempty = false;
        this.nameTxt = '您搜索的暂无找到';
      }
      this.currentPage = data.number + 1;
      this.pagesize = data.size;
      this.total = data.totalElements;
    });
  }
  //清空搜索
  resetForm(formName) {
    (this.$refs[formName] as any).resetFields();
    this.getPagination(0);
  }
  //添加品牌事件
  add_Brand() {
    this.dialog = true;
    this.Title = '添加品牌';
    this.PropsData = {};
  }
  //关闭抽屉
  isDialog(v) {
    this.dialog = v;
  }
  //分页器事件
  handleCurrentChange(val) {
    this.getPagination(val - 1);
  }
  //搜索框搜索方法
  submitForm(formName) {
    (this.$refs[formName] as any).validate((valid) => {
      this.GetBrandsList(); //执行搜索方法
    });
  }
  //表格的编辑按钮事件
  handleClick(row) {
    this.Title = '编辑品牌';
    this.dialog = true;
    let data = JSON.parse(JSON.stringify(row));
    this.PropsData = data;
  }
  //表格的删除按钮事件
  deleteClick(v) {
    this.table_row = v;
    this.$confirm('该品牌将永久删除, 是否继续?', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.DelBland();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
  }
  //删除品牌的接口方法
  DelBland() {
    delBrand({
      brandId: this.table_row['brandId'],
    }).then((data) => {
      this.$message({
        type: 'success',
        message: '删除成功!',
      });
      this.getPagination(this.currentPage - 1);
    });
  }
  //子组件提交数据时，传递来的方法[调用请求表格数据的方法]
  flush() {
    this.getPagination(this.currentPage - 1);
  }
}
